import { AlertTriangle } from '@untitledui/icons'

interface LoginErrorProps {
    message: string
}

/**
 * What went wrong on one of the login pages.
 */
const LoginError = ({ message }: LoginErrorProps) => (
    <p className="m-0 flex items-center gap-2 font-bold text-[#ff0000]">
        <AlertTriangle className="size-5 shrink-0" />
        {message}
    </p>
)

export default LoginError
